// addEventListener<K extends keyof DocumentEventMap>(type: K, listener: (this: Document, ev: DocumentEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;
// addEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void;

export function addElemEventListener<K extends keyof HTMLElementEventMap>(
  elem: HTMLElement | None,
  type: K,
  listener: (ev: HTMLElementEventMap[K]) => unknown,
  options?: boolean | AddEventListenerOptions,
): () => void {
  if (!elem || !import.meta.client || !document) return () => {
    //
  }
  elem?.addEventListener(type, listener, options)
  return () => elem?.removeEventListener(type, listener, options)
}

export function useEventListener<K extends keyof DocumentEventMap>(
  type: K,
  listener: (ev: DocumentEventMap[K]) => unknown,
  options?: boolean | AddEventListenerOptions,
): () => void {
  if (!import.meta.client || !document) return () => {
    //
  }
  document.addEventListener(type, listener, options)
  return () => document.removeEventListener(type, listener, options)
}
